// const Config = () => {
//   const config = {
//     bucketName: "ats-bucket-hardware",
//     dirName: "photos",
//     error: "",
//     region: "us-east-1",
//     accessKeyId: "AKIA44SH2DQ6NF3SXOFL",
//     secretAccessKey: "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",
//     headers: {
//       "Access-Conrol-Allow-Origin": "*",
//     },
//   };

//   return config;
// };

// export default Config;

const Config = () => {
  const config = {
    bucketName: process.env.REACT_APP_AWS_BUCKET_NAME,
    dirName: "photos",
    error: "",
    region: process.env.REACT_APP_AWS_REGION,
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
    headers: {
      "Access-Control-Allow-Origin": "*", // Fixing typo in header key
    },
  };

  return config;
};

export default Config;
